import React from 'react';

import api from 'services';

import AutoComplete from 'material-ui/AutoComplete';

class Manager extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            companies: [],
            managerObject: props.managerObject,
        };

        this.changeAutoCompete = this.changeAutoCompete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            managerObject: nextProps.managerObject,
        });
    }

    changeAutoCompete(searchText) {
        this.setState({
            managerObject: {
                name: searchText,
                _id: '',
            },
        }, () => {
            if(searchText) {
                api.findCompany(searchText)
                    .then((response) => {
                        if (response.status === 200) {
                            const companies = response.data.data.map(company => ({
                                name: company.name,
                                company,
                            }));
    
                            this.setState({
                                companies,
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error AutoComplete companies - manager component', error);
                        return null;
                    });
            }
        });

    }

    chooseAutoComplete(updateProperties) {
        this.setState({
            managerObject: updateProperties.company,
        }, () => {
            this.props.changeAutoComplete('manager', updateProperties.company);
        });
    }

    render() {
        const { companies, managerObject } = this.state;
        const { getError, confirmed, modifiedFields, underStyle } = this.props;

        return (
            <AutoComplete
                disabled={confirmed}
                name='manager'
                floatingLabelText='Manager'
                searchText={managerObject.name}
                dataSource={companies}
                dataSourceConfig={{ text: 'name', value: 'company' }}
                onUpdateInput={this.changeAutoCompete}
                onNewRequest={this.chooseAutoComplete}
                filter={AutoComplete.noFilter}
                errorText={getError('manager')}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{
                    canAutoPosition: true,
                }}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('manager') ? underStyle : null}
            />
        );
    }
}

export default Manager;


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Manager.jsx